
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 22a10.018 10.018 0 01-5-1.338.5.5 0 01.5-.866A9 9 0 103 12a.5.5 0 01-1 0 10 10 0 1110 10z"}}),_c('path',{attrs:{"d":"M2.5 12.5a.48.48 0 01-.158-.026.5.5 0 01-.289-.25l-2-4a.5.5 0 01.895-.448l1.776 3.553 3.553-1.777a.5.5 0 11.447.894l-4 2a.5.5 0 01-.224.054zm13.036 3.536a.5.5 0 01-.354-.147l-3.535-3.535A.5.5 0 0111.5 12V7a.5.5 0 011 0v4.793l3.389 3.389a.5.5 0 01-.353.854z"}})])
          )
        }
      }
    